<template>
  <div class="card">
    <div class="card-title" @click.prevent="toggleAccordion">
      <slot name="titleSlot"></slot>
    </div>
    <div v-if="isOpen" class="card-body">
      <div class="card__content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { icons } from "../../utils/icons";
export default {
  props: ["id", "accordionTitle", "customStyles", "isOpen"],
  emits: ["clicked"],
  data() {
    return {
      icons: icons,
    };
  },
  methods: {
    toggleAccordion() {
      this.$emit("clicked", this.id);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/styles/variables.less";

.card {
  &-title {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    cursor: pointer;
    padding: 0 0.5rem;
  }
  &-body {
    padding: 12px;
    overflow: hidden;
  }
}
</style>
